export default __webpack_public_path__ + "static/media/cert4.edc7b700.jpg";